import React, { Component } from 'react';
import CheckManual from '../../assets/images/checked-manually.png'
import Cookies from 'js-cookie';
import LanguageContext from "../../context/LanguageProvider";

export class CheckManually extends Component {
    static contextType = LanguageContext;
    render() {
        const vin = Cookies.get('vin')
        const { lang } = this.context;
        return (
            <>
                <div className="col-lg-8 col-md-12 col-sm-12 d-flex all-underbody-col image-modal-col">
                    <div className="card-main card ">
                        <div className="card-body">
                            <div className="place-image-here-content">
                                <div className="empty-card">
                                    <img src={CheckManual} alt="Click on VIN to view underbody image" />
                                </div>
                                <div className="all-title car-title mt-3">
                                    <p className="small-text-16">{lang("Your")} <span>{lang("VIN")} {vin} </span> {lang("is checked manually.")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default CheckManually;
